import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { ToastInfo, ToastType } from 'src/app/plugins/toasts/toasts-info';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private toastConfig = {
    autoDismissTimeout: 5000
  };
  private toastQueue: ToastInfo[] = [];
  private toastEmitter = new Subject<ToastInfo[]>();
  private currentMouseOverToastId: string = '';
  private toasterLength: any;

  constructor() { }

  // function accepts heading, content, toastType
  // if heading, content has diffrent data then it assigns new data to toast id heading content
  public showToastr(heading: string, content: any, toastType : ToastType) {
    if ((this.toastQueue.length === 0 || (this.toastQueue.length >= 1 && this.toastQueue[0].heading !== heading && this.toastQueue[0].content !== content))) {
      const toastId = 'toast-' + new Date().getTime();
      this.toastQueue.unshift({
        id : toastId,
        heading,
        content,
        type: toastType,
      }); 

      this.toasterLength = this.toastConfig.autoDismissTimeout;

      this.toastEmitter.next(this.toastQueue);
      this.removeToastOnTimeout(toastId);
    }
  }

  public getToasts(): Observable<ToastInfo[]> {
    return this.toastEmitter.asObservable();
  }

  // closes the toast
  public removeToast(toastId: string): void {
    this.toastQueue = this.toastQueue.filter((toast) => {
      return toast.id !== toastId;
    });
    this.toastEmitter.next(this.toastQueue);
  }

// this function accepts toastID
// if the currentMouseOverToastId is same as toastId then removeToastOnTimeout is called
// else it removeToast is called
  private removeToastOnTimeout(toastId: string): void {

    setTimeout(() => {
      if (this.currentMouseOverToastId === toastId) {
        this.removeToastOnTimeout(toastId);
      } else {
        this.removeToast(toastId);
      }
    }, this.toasterLength);
  }

}
